import React, { useState } from 'react';

const getDateRange = (filter) => {
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const end = new Date();
  end.setHours(23, 59, 59, 999);

  switch (filter) {
    case 'today':
      return { start, end };
    case 'yesterday':
      start.setDate(start.getDate() - 1);
      end.setDate(end.getDate() - 1);
      return { start, end };
    case 'week': {
      start.setDate(start.getDate() - start.getDay());
      return { start, end };
    }
    case 'month':
      start.setDate(1);
      return { start, end };
    case 'year':
      start.setMonth(0, 1);
      return { start, end };
    default:
      return null;
  }
};

const isInRange = (item, dateField, range) => {
  if (!range) return true;
  const d = new Date(item[dateField]);
  return d >= range.start && d <= range.end;
};

const DateFilter = ({ data, dateField = 'createdAt', onFilteredData, title = 'Report', columns }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');

  const filters = [
    { key: 'all', label: 'All' },
    { key: 'today', label: 'Today' },
    { key: 'yesterday', label: 'Yesterday' },
    { key: 'week', label: 'Week' },
    { key: 'month', label: 'Month' },
    { key: 'year', label: 'Year' },
    { key: 'custom', label: 'Custom' },
  ];

  const getFilteredData = () => {
    if (activeFilter === 'all') return data;
    if (activeFilter === 'custom') {
      if (!customStart || !customEnd) return data;
      const s = new Date(customStart);
      s.setHours(0, 0, 0, 0);
      const e = new Date(customEnd);
      e.setHours(23, 59, 59, 999);
      return data.filter((item) => {
        const d = new Date(item[dateField]);
        return d >= s && d <= e;
      });
    }
    const range = getDateRange(activeFilter);
    return range ? data.filter((item) => isInRange(item, dateField, range)) : data;
  };

  const filteredData = getFilteredData();

  React.useEffect(() => {
    if (onFilteredData) onFilteredData(filteredData);
  }, [filteredData, onFilteredData]);

  const exportPDF = () => {
    const win = window.open('', '_blank');
    const headerRow = columns.map((c) => `<th style="background:#1a4a2e;color:#fff;padding:8px;text-align:left;font-size:12px">${c.Header}</th>`).join('');
    const bodyRows = filteredData.map((item) => {
      const cells = columns
        .map((c) => {
          const val = c.accessor.split('.').reduce((o, k) => (o ? o[k] : undefined), item);
          return `<td style="padding:6px 8px;border-bottom:1px solid #eee;font-size:11px">${val !== undefined && val !== null ? val : ''}</td>`;
        })
        .join('');
      return `<tr>${cells}</tr>`;
    }).join('');

    win.document.write(`
      <html>
      <head><title>${title}</title>
      <style>
        body { font-family: Arial,sans-serif; padding:30px; }
        .header { text-align:center; border-bottom:2px solid #1a4a2e; padding-bottom:15px; margin-bottom:20px; }
        .header h1 { color:#1a4a2e; font-size:24px; margin:0; }
        table { width:100%; border-collapse:collapse; margin-top:20px; }
        th { background:#1a4a2e; color:#fff; padding:8px; text-align:left; font-size:12px; }
        td { padding:6px 8px; border-bottom:1px solid #eee; font-size:11px; }
        tr:nth-child(even) td { background:#f9f9f9; }
        .footer { text-align:center; margin-top:30px; color:#1a4a2e; font-size:12px; }
        .print-btn { text-align:center; margin-top:20px; }
        .print-btn button { background:#1a4a2e; color:#fff; border:none; padding:10px 30px; font-size:14px; cursor:pointer; border-radius:4px; }
        @media print { .print-btn { display:none; } }
      </style></head>
      <body>
        <div class="header"><h1>${title}</h1></div>
        <p><strong>Filter:</strong> ${activeFilter.toUpperCase()} | <strong>Generated:</strong> ${new Date().toLocaleString('en-IN')} | <strong>Records:</strong> ${filteredData.length}</p>
        <table><thead><tr>${headerRow}</tr></thead><tbody>${bodyRows}</tbody></table>
        <div class="footer">TN Dry Fruits - Report</div>
        <div class="print-btn"><button onclick="window.print()">Print / Save PDF</button></div>
      </body></html>
    `);
    win.document.close();
  };

  return (
    <div className="d-flex flex-wrap align-items-center gap-2 mb-3" style={{ gap: '8px' }}>
      {filters.map((f) => (
        <button
          key={f.key}
          className={`btn btn-sm ${activeFilter === f.key ? 'btn-success' : 'btn-outline-success'}`}
          onClick={() => setActiveFilter(f.key)}
        >
          {f.label}
        </button>
      ))}
      {activeFilter === 'custom' && (
        <>
          <input type="date" className="form-control form-control-sm" style={{ width: 150 }} value={customStart} onChange={(e) => setCustomStart(e.target.value)} />
          <span className="text-white mx-1">to</span>
          <input type="date" className="form-control form-control-sm" style={{ width: 150 }} value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} />
        </>
      )}
      <button className="btn btn-sm btn-primary ml-2" onClick={exportPDF} disabled={filteredData.length === 0}>
        Export PDF
      </button>
      <span className="text-white ml-2" style={{ fontSize: 13 }}>Count: {filteredData.length}</span>
    </div>
  );
};

export default DateFilter;